import React from "react";
import { Link } from "react-router-dom";
import Newsletter from "./Newsletter";
import { Instagram, MapPin, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-footer-bg text-footer-fg mt-auto" data-testid="main-footer">
      <div className="container-page py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          <div className="md:col-span-2">
            <div className="text-3xl font-display mb-3">अन्वय</div>
            <p className="text-footer-fg/70 max-w-sm mb-4">
              Family & Systemic Constellation work with Arjunna Soni. Grounded,
              confidential, non-mystical. In Ludhiana and online.
            </p>
            <div className="space-y-1.5 text-sm text-footer-fg/70">
              <p className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 shrink-0" /> 81/7 Mall Road, Civil Lines, Ludhiana (Pb)-141001</p>
              <p className="flex items-center gap-2"><Phone size={16} /> +91 9115423336</p>
              <a href="https://instagram.com/arjunnasoni" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-gold transition-colors"><Instagram size={16} /> @arjunnasoni</a>
            </div>
          </div>

          <div>
            <div className="label-caps text-gold mb-4">Explore</div>
            <ul className="space-y-2.5 text-sm text-footer-fg/70">
              <li><Link to="/services" className="hover:text-gold transition-colors">Services</Link></li>
              <li><Link to="/workshops" className="hover:text-gold transition-colors">Workshops</Link></li>
              <li><Link to="/resources" className="hover:text-gold transition-colors">Resources</Link></li>
              <li><Link to="/testimonials" className="hover:text-gold transition-colors">Client Stories</Link></li>
              <li><Link to="/faq" className="hover:text-gold transition-colors">FAQ</Link></li>
              <li><Link to="/contact" className="hover:text-gold transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <div className="label-caps text-gold mb-4">Stay in touch</div>
            <p className="text-sm text-footer-fg/70 mb-3">Occasional, thoughtful notes. No noise.</p>
            <Newsletter source="footer" dark />
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-sm text-footer-fg/60">
          <p>© {new Date().getFullYear()} अन्वय — Arjunna Soni. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/privacy-policy" className="hover:text-gold transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:text-gold transition-colors">Terms</Link>
            <Link to="/disclaimer" className="hover:text-gold transition-colors">Disclaimer</Link>
          </div>
        </div>
        <p className="mt-6 text-xs text-footer-fg/40 max-w-3xl">
          Constellation work is an experiential complementary modality. It is not a substitute for medical or psychiatric
          treatment, and is not appropriate as sole care during an acute mental health crisis.
        </p>
      </div>
    </footer>
  );
}
